import React from 'react'

interface IconProps {
  className?: string
}

const Pointer = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.80425 3C3.23338 3 2.27569 4.7279 3.10825 6.06L6.82075 12L3.10825 17.94C2.27569 19.2721 3.23338 21 4.80425 21H14.5C15.1295 21 15.7223 20.7036 16.1 20.2L21.35 13.2C21.8833 12.4889 21.8833 11.5111 21.35 10.8L16.1 3.8C15.7223 3.29639 15.1295 3 14.5 3H4.80425Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export default Pointer
